import { render, staticRenderFns } from "./InvoiceRequest.vue?vue&type=template&id=22dda2be&scoped=true"
import script from "./InvoiceRequest.vue?vue&type=script&lang=js"
export * from "./InvoiceRequest.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRequest.vue?vue&type=style&index=0&id=22dda2be&prod&scoped=true&lang=css"
import style1 from "./InvoiceRequest.vue?vue&type=style&index=1&id=22dda2be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dda2be",
  null
  
)

export default component.exports